<main class="flex-shrink-0">
  <router-outlet></router-outlet>
  <app-footer></app-footer>
  <app-btn-scroll-to-top></app-btn-scroll-to-top>
</main>